import React from 'react'
import { Form, Dropdown, DropdownButton } from 'react-bootstrap';
import "../css/MainDropdown.css"
const MainDropdown = ({ label, options, onSelect , langDir = "en" , title , displayKey = "name" , forceWidth = false }) => {
  return <>


<div className={forceWidth ? "coolinputFullWidth mx-auto" : "coolinput mx-auto"}>
      <label htmlFor="input" className={langDir === "en" ? "text" : "textAr"}>{label}</label>
      <DropdownButton
        id="dropdown-basic-button"
        title={title}
        variant=""
        className={langDir === "en" ?  "custom-dropdown" : "custom-dropdownAr" }
      >
        {options.map((option, index) => (
          <Dropdown.Item key={index} onClick={() => onSelect(option._id)}>
           {option[displayKey] || "Unnamed"}
          </Dropdown.Item>
        ))}
      </DropdownButton>
    </div>


 


  </>
}

export default MainDropdown